import LazyLoad from 'vanilla-lazyload';
import Alpine from 'alpinejs';
import { Collapse } from 'bootstrap'; // eslint-disable-line no-unused-vars
// import lottie from 'lottie-web';
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import videojs from 'video.js';
import AOS from 'simple-aos';

import '../components/video';
import '../components/parallax';

// initialize lazyload
const initLazyLoad = new LazyLoad();
initLazyLoad.update();

AOS.init({
	disable: window.matchMedia('(prefers-reduced-motion: reduce)'), // reduce motion when user has set prefers-reduced-motion for accessibility
	easing: 'ease-in-out',
	duration: 800,
	offset: 80,
	anchorPlacement: 'top-bottom',
	once: true,
});
window.Alpine = Alpine;

/**
 * * Journey Animation
 */

Alpine.data('deeperdiveJourney', () => ({
	activeStep: 1,
	markerY: 0,
	navTarget: null,
	syncMarker() {
		const track = this.$root.querySelector('.journey-numbers-track');
		const idx = this.$root.querySelector(
			`.journey-numbers .journey-numbers-item:nth-child(${this.activeStep}) .journey-numbers-item__index`,
		);
		if (!track || !idx) return;
		this.markerY =
			idx.getBoundingClientRect().top -
			track.getBoundingClientRect().top +
			track.scrollTop;
	},
	computeStepFromScroll() {
		const panels = [...this.$root.querySelectorAll('.journey-item')];
		if (!panels.length) return 1;
		const line = window.innerHeight * 0.35;
		for (let i = panels.length - 1; i >= 0; i -= 1) {
			if (panels[i].getBoundingClientRect().top <= line) return i + 1;
		}
		return 1;
	},
	applySpy() {
		const next = this.computeStepFromScroll();
		const changed = this.activeStep !== next;
		if (changed) this.activeStep = next;
		return changed;
	},
	init() {
		const panels = [...this.$root.querySelectorAll('.journey-item')];
		if (!panels.length) return;
		let ticking = false;
		const updateFromScroll = () => {
			if (this.navTarget !== null) return false;
			return this.applySpy();
		};
		const flush = () => {
			if (updateFromScroll()) this.syncMarker();
			ticking = false;
		};
		const onScroll = () => {
			if (!ticking) {
				requestAnimationFrame(flush);
				ticking = true;
			}
		};
		const endNav = () => {
			if (this.navTarget === null) return;
			this.navTarget = null;
			this.applySpy();
			this.syncMarker();
		};
		this.applySpy();
		this.$nextTick(() => this.syncMarker());
		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('scrollend', endNav, { passive: true });
		window.addEventListener('resize', () => {
			requestAnimationFrame(() => {
				if (this.navTarget === null) this.applySpy();
				this.syncMarker();
			});
		});
	},
	scrollToStep(n) {
		this.navTarget = n;
		this.activeStep = n;
		this.$nextTick(() => this.syncMarker());
		const panel = this.$root.querySelector(`#journey-panel-${n}`);
		if (!panel) return;
		panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
		window.setTimeout(() => {
			if (this.navTarget !== n) {
				return;
			}
			this.navTarget = null;
			this.applySpy();
			this.syncMarker();
		}, 900);
	},
}));

Alpine.start();

/*
 * * logos-swiper
 */
['.logos-swiper', '.logos-form-swiper'].forEach((selector) => {
	const el = document.querySelector(selector);
	if (!el) return;
	// is-static: 5 or fewer logos (templates/deeperdive.php)
	const wideScreen = el.classList.contains('is-static')
		? {
				// Slides sized by their logo, spread by space-between in the SCSS
				slidesPerView: 'auto',
				spaceBetween: 0,
				autoplay: { delay: 2000 },
				freeMode: { enabled: false },
				loop: false,
			}
		: {
				// Keeps scrolling, 5 at a time; loop needs slidesPerView + 1
				// + loopAdditionalSlides slides, so 0 extra lets 6 logos loop
				slidesPerView: 5,
				loopAdditionalSlides: 0,
			};
	// eslint-disable-next-line no-new
	new Swiper(selector, {
		modules: [Autoplay],
		slidesPerView: 2,
		spaceBetween: 40,
		slidesPerGroup: 1,
		loop: true,
		speed: 3000,
		autoplay: { delay: 0, disableOnInteraction: false },
		allowTouchMove: true,
		freeMode: { enabled: true, momentum: false },
		loopAdditionalSlides: 2,
		breakpoints: {
			436: { slidesPerView: 3 },
			768: { slidesPerView: 3 },
			1200: wideScreen,
		},
	});
});

const newsSwiperEl = document.querySelector('.news-swiper');
if (newsSwiperEl) {
	// eslint-disable-next-line no-new
	new Swiper(newsSwiperEl, {
		modules: [Autoplay],
		loop: true,
		slidesPerView: 1,
		spaceBetween: 24,
		autoplay: { delay: 3000, disableOnInteraction: false },
		breakpoints: {
			768: { slidesPerView: 2, spaceBetween: 24 },
			992: { slidesPerView: 3, spaceBetween: 24 },
		},
	});
}

/**
 *  * * Video Player
 */

const muteButton = document.querySelector('.mute-button');
const muteIcon = document.querySelector('.mute-icon');
const unmuteIcon = document.querySelector('.unmute-icon');
const playPauseButton = document.querySelector('.play-pause-button');
const playIcon = document.querySelector('.play-icon');
const pauseIcon = document.querySelector('.pause-icon');

const player = videojs('full-intro-video', {
	playsinline: true,
	autoplay: true,
	muted: true,
	loop: true,
	controls: false,
});

player.addClass('vjs-realize');
player.bigPlayButton.hide();

player.controlBar.hide();

playPauseButton.addEventListener('click', (e) => {
	e.preventDefault();
	if (player.paused()) {
		player.play();
		playIcon.classList.add('d-none');
		pauseIcon.classList.remove('d-none');
	} else {
		player.pause();
		playIcon.classList.remove('d-none');
		pauseIcon.classList.add('d-none');
	}
});

muteButton.addEventListener('click', (e) => {
	e.preventDefault();
	const isMuted = player.muted();
	player.muted(!isMuted);
	if (isMuted) {
		muteIcon.classList.add('d-none');
		unmuteIcon.classList.remove('d-none');
	} else {
		muteIcon.classList.remove('d-none');
		unmuteIcon.classList.add('d-none');
	}
});

player.on('play', () => {
	playIcon.classList.add('d-none');
	pauseIcon.classList.remove('d-none');
	player.bigPlayButton.el().classList.add('vjs-hidden');
	player.bigPlayButton.el().style.display = 'none';
	const posterEl = player.el().querySelector('.vjs-poster');
	if (posterEl) {
		posterEl.style.display = 'none';
	}
});

player.on('pause', () => {
	playIcon.classList.remove('d-none');
	pauseIcon.classList.add('d-none');
});

player.on('ended', () => {
	player.currentTime(0);
	player.play();
});

player.on('loadeddata', () => {
	const posterEl = player.el().querySelector('.vjs-poster');
	if (posterEl) {
		posterEl.style.display = 'none';
	}
});

/**
 * * Flow Animation
 */

// const flowAnimationEl = document.querySelector('.flow-animation');
// const flowAnimationPath = flowAnimationEl?.getAttribute('data-animation');

// if (flowAnimationEl && flowAnimationPath) {
// 	const prefersReducedMotion = window.matchMedia(
// 		'(prefers-reduced-motion: reduce)',
// 	).matches;

// 	if (prefersReducedMotion) {
// 		lottie.loadAnimation({
// 			container: flowAnimationEl,
// 			renderer: 'svg',
// 			loop: true,
// 			autoplay: true,
// 			path: flowAnimationPath,
// 		});
// 	} else {
// 		const flowAnim = lottie.loadAnimation({
// 			container: flowAnimationEl,
// 			renderer: 'svg',
// 			loop: false,
// 			autoplay: false,
// 			path: flowAnimationPath,
// 		});

// 		// >1 finishes the Lottie before the section finishes crossing the viewport
// 		const flowScrollFinishAhead = 1.8;

// 		const syncFlowScroll = () => {
// 			if (!flowAnim.totalFrames) {
// 				return;
// 			}
// 			// Measure the Lottie box so scrub starts when this element enters view,
// 			// not when the taller .flow section does.
// 			const rect = flowAnimationEl.getBoundingClientRect();
// 			const vh = window.innerHeight;
// 			const range = vh + rect.height;
// 			const rawProgress = Math.min(
// 				1,
// 				Math.max(0, (vh - rect.top) / range),
// 			);
// 			const progress = Math.min(1, rawProgress * flowScrollFinishAhead);
// 			const frame = progress * (flowAnim.totalFrames - 1);
// 			flowAnim.goToAndStop(frame, true);
// 		};

// 		let flowScrollTicking = false;
// 		const onFlowScroll = () => {
// 			if (!flowScrollTicking) {
// 				requestAnimationFrame(() => {
// 					syncFlowScroll();
// 					flowScrollTicking = false;
// 				});
// 				flowScrollTicking = true;
// 			}
// 		};

// 		flowAnim.addEventListener('DOMLoaded', syncFlowScroll);
// 		window.addEventListener('scroll', onFlowScroll, { passive: true });
// 		window.addEventListener('resize', onFlowScroll);
// 	}
// }
